import React from "react";
import { DrawerModal } from "../drawer-modal/drawer-modal";
import styles from "./add-new-gateway-drawer-modal.module.scss";
import { Title } from "@src/components/atoms/title/title";
import { FlexColumnContainer } from "@src/components/templates/layouts/flex-column-container/flex-column-container";
import { NewOnboardingStepper } from "@src/components/atoms/new-onboarding-stepper/new-onboarding-stepper";
import onboardingGateway0 from "@src/assets/svg/onboarding-gateway-0.svg";
import onboardingGatewayCompleted from "@src/assets/svg/onboarding-gateway-completed.svg";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import { TextButton } from "@src/components/atoms/buttons/text-button/text-button";
import { GatewayAnnouncementStatus } from "./gateway-announcement-status/gateway-announcement-status";
import { ButtonWithLoader } from "@src/components/atoms/buttons/button-with-loader/button-with-loader";
import { HelpIconPopover } from "@src/components/atoms/help-icon-popover/help-icon-popover";
import { useAddNewGatewayDrawerModal } from "./use-add-new-gateway-drawer-modal-hook";

const cssClassName = "add-new-gateway-drawer-modal";

export const AddNewGatewayDrawerModal = () => {
  const {
    texts,
    onboardingKey,
    setOnboardingKey,
    isGatewayInputDisabled,
    isConnectGatewayLoading,
    showGatewayConnectButton,
    showFinishOnboardingButtons,
    isFinishOnboardingButtonEnabled,
    isContinueMachineOnboardingEnabled,
    announcementStatus,
    gatewayOnboardingStatus,
    isGatewayOnboardingCompleted,
    steps,
    gatewayDetails,
    operationFailureReason,
    operationFailureDetails,
    showProtocolDetails,
    isGatewayAnnounced,
    isGatewayAlreadyOnboarded,
    handleConnectGatewayClick,
    handleRetry,
    handleShowProtocol,
    handleGetSupport,
    handleFinishAndGoToGateway,
    handleContinueMachineOnboarding,
    handleCloseGatewayDrawer,
  } = useAddNewGatewayDrawerModal();

  return (
    <DrawerModal
      id="addNewGatewayDrawerModal"
      onClose={handleCloseGatewayDrawer}
    >
      <div className={styles[cssClassName]}>
        <FlexColumnContainer verticalGap={24}>
          <Title tag="h2" text={texts.title} />
          <div className={styles[`${cssClassName}__steps-card`]}>
            <img
              className={styles[`${cssClassName}__gateway-icon`]}
              src={
                isGatewayOnboardingCompleted
                  ? onboardingGatewayCompleted
                  : onboardingGateway0
              }
              alt=""
            />
            <NewOnboardingStepper steps={steps} />
          </div>
          <p className={styles[`${cssClassName}__section-title`]}>
            {texts.gatewayOnboardingSection}
          </p>

          <div className={styles[`${cssClassName}__input-container`]}>
            <FlexRowContainer horizontalGap={8} justifyContent="space-between">
              <label
                className={styles[`${cssClassName}__label`]}
                htmlFor="newGatewayOnboardingKey"
              >
                {texts.onboardingKey}
              </label>
              <HelpIconPopover
                helpLabel={texts.help}
                helpText={texts.onboardingKeyHelpText}
              />
            </FlexRowContainer>
            <input
              id="newGatewayOnboardingKey"
              type="text"
              value={onboardingKey}
              disabled={isGatewayInputDisabled}
              placeholder="1234-5678-910!"
              className={styles[`${cssClassName}__input`]}
              onChange={(e) => setOnboardingKey(e.target.value)}
            />
          </div>

          <GatewayAnnouncementStatus
            announcementStatus={announcementStatus}
            gatewayOnboardingStatus={gatewayOnboardingStatus}
            gatewayDetails={gatewayDetails}
            failureReason={operationFailureReason}
            failureDetails={operationFailureDetails}
            showProtocolDetails={showProtocolDetails}
            isGatewayAnnounced={isGatewayAnnounced}
            isGatewayAlreadyOnboarded={isGatewayAlreadyOnboarded}
            onRetry={handleRetry}
            onOnboardAnotherGateway={handleCloseGatewayDrawer}
            onShowProtocol={handleShowProtocol}
            onGetSupport={handleGetSupport}
          />

          {showGatewayConnectButton && (
            <ButtonWithLoader
              variant={["full-width"]}
              fun={handleConnectGatewayClick}
              text={texts.connectGatewayButton}
              loading={isConnectGatewayLoading}
              disabled={!onboardingKey.trim()}
              spinnerVariant={["secondary", "small"]}
            />
          )}

          {showFinishOnboardingButtons && (
            <FlexColumnContainer verticalGap={12}>
              <ButtonWithLoader
                fun={handleContinueMachineOnboarding}
                text={texts.continueMachineOnboarding}
                disabled={!isContinueMachineOnboardingEnabled}
                tooltip={
                  isFinishOnboardingButtonEnabled &&
                  !isContinueMachineOnboardingEnabled
                    ? texts.continueMachineOnboardingDisabled
                    : undefined
                }
                variant={["full-width"]}
                spinnerVariant={["secondary", "small"]}
              />
              <div className={styles[`${cssClassName}__secondary-action`]}>
                <TextButton
                  clickHandler={handleFinishAndGoToGateway}
                  text={texts.finishAndGoToGateway}
                  variant="blue"
                  disabled={!isFinishOnboardingButtonEnabled}
                />
              </div>
            </FlexColumnContainer>
          )}
        </FlexColumnContainer>
      </div>
    </DrawerModal>
  );
};
